import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_IN_UQ || "uqin-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_IN_UQ || 0,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_IN_UQ || 0,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_IN_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_IN_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_IN_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_IN_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true
};

export default _countryEnv;
